// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XkpkI","text":"styles_text__lbHy9"};